import React from 'react';

const FundingMatchReasons = ({ reasons = [], risks = [], missingRequirements = [] }) => {
  if (!reasons.length && !risks.length && !missingRequirements.length) {
    return <p className="text-sm text-[var(--fg-muted)]">No match details available.</p>;
  }

  return (
    <div className="space-y-3 text-sm">
      {reasons.length > 0 ? (
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-[var(--fg-accent)]">Reasons</div>
          <ul className="mt-1.5 space-y-1 text-[var(--fg-text)]">
            {reasons.map((item) => (
              <li key={item} className="flex gap-2">
                <span className="text-[var(--fg-accent)]">+</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {risks.length > 0 ? (
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-amber-600 dark:text-amber-300">Risks</div>
          <ul className="mt-1.5 space-y-1 text-[var(--fg-text)]">
            {risks.map((item) => (
              <li key={item} className="flex gap-2">
                <span className="text-amber-600 dark:text-amber-300">!</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}

      {missingRequirements.length > 0 ? (
        <div>
          <div className="text-xs font-semibold uppercase tracking-wide text-rose-600 dark:text-rose-300">Missing requirements</div>
          <ul className="mt-1.5 space-y-1 text-[var(--fg-text)]">
            {missingRequirements.map((item) => (
              <li key={item} className="flex gap-2">
                <span className="text-rose-600 dark:text-rose-300">-</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default FundingMatchReasons;
